module.exports = __webpack_public_path__ + "static/media/round_icon.4c652688.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/round_icon.svg
// module id = 61
// module chunks = 0